<div class="container news">
    <div class="row d-flex justify-content-center">
        <h2 class="pb-5">News</h2>
    </div>
    <div class="row d-flex justify-content-center">
        <nb-route-tabset
            [tabs]="tabs"
            class="routeTabsetNews"
        ></nb-route-tabset>
        <div class="col-sm-8">
            <nb-card>
                <nb-card-body>
                    <!-- <div *ngFor="let singleNews of news"> -->
                    <div class="row">
                        <div class="col-sm">
                            <img
                                class="img-responsive img-fluid img-featured pb-5"
                                src="../../../assets/images/EliteLaunchpadForEveryone.jpeg"
                                alt="The elite launchpad for everyone"
                            />
                        </div>
                    </div>
                    <div class="row justify-content-start">
                        <div class="col-sm">
                            <h3>{{ news[0]["attributes"]["title"] }}</h3>
                            <p>
                                {{ news[0]["attributes"]["description"] }}
                            </p>
                        </div>
                    </div>
                    <nb-card-footer>
                        <div class="row">
                            <div class="col-sm">
                                <div class="d-flex">
                                    <img
                                        class="img-responsive img-fluid lbLogo"
                                        src="../../../assets/images/Logo.png"
                                        alt="LitBitLogo"
                                    />
                                    <!-- TODO: POPRAVI LOGO ASAP-->
                                    <p class="ml-3">
                                        Litbit<br />{{
                                            news[0]["attributes"][
                                                "datePublished"
                                            ]
                                        }}
                                    </p>
                                </div>
                            </div>

                            <!-- <p>{{news[0]['attributes']["categories"]}}</p> -->
                        </div>
                    </nb-card-footer>
                    <!-- </div> -->
                </nb-card-body>
                <div class="d-flex justify-content-center">
                    <a
                        nbButton
                        class="btn btnMiddle"
                        status="primary"
                        href="{{ '/news/single/' + news[0]['id'] }}"
                        status="primary"
                        >Read More</a
                    >
                </div>
            </nb-card>
        </div>
    </div>

    <div class="row d-flex justify-content-center mt-2 pb-5 mb-5">
        <div class="col-sm-4">
            <nb-card size="medium">
                <nb-card-body>
                    <div class="row justify-content-start">
                        <div class="col-sm">
                            <img
                                class="img-responsive img-fluid w-100 pb-5"
                                src="../../../assets/images/place1.png"
                                alt="Picture"
                            />
                        </div>
                    </div>
                    <div class="row justify-content-start">
                        <div class="col-sm">
                            <h3>{{ news[1]["attributes"]["title"] }}</h3>
                            <p>
                                {{ news[1]["attributes"]["description"] }}
                            </p>
                        </div>
                    </div>
                </nb-card-body>
                <div class="d-flex justify-content-center">
                    <a
                        nbButton
                        class="btn btnMiddle"
                        status="primary"
                        href="{{ '/news/single/' + news[1]['id'] }}"
                        status="primary"
                        >Read More</a
                    >
                </div>
            </nb-card>
        </div>
        <div class="col-sm-4">
            <nb-card size="medium">
                <nb-card-body>
                    <div class="row justify-content-start">
                        <div class="col-sm">
                            <img
                                class="img-responsive img-fluid w-100 pb-5"
                                src="../../../assets/images/place1.png"
                                alt="Picture"
                            />
                        </div>
                    </div>
                    <div class="row justify-content-start">
                        <div class="col-sm">
                            <h3>{{ news[2]["attributes"]["title"] }}</h3>
                            <p>
                                {{ news[2]["attributes"]["description"] }}
                            </p>
                        </div>
                    </div>
                </nb-card-body>
                <div class="d-flex justify-content-center">
                    <a
                        nbButton
                        class="btn btnMiddle"
                        status="primary"
                        href="{{ '/news/single/' + news[2]['id'] }}"
                        status="primary"
                        >Read More</a
                    >
                </div>
            </nb-card>
        </div>
    </div>
</div>
